
import { Box } from '@mui/system';
import Stack from '@mui/material/Stack';
import { Card, CardHeader, CardContent } from '@mui/material';

import { useBoolean } from 'src/hooks/use-boolean';
import { useOrgTenant } from 'src/hooks/auth/use-org-tenant';

import { useTranslate } from 'src/locales';
import PostCommentForm from 'src/layouts/common/threads/post-comment-form';
import PostCommentList from 'src/layouts/common/threads/post-comment-list';
import { useGetContactByIdQuery } from 'src/services/contacts/contacts.service';

import Iconify from 'src/components/iconify';




type Props = {
  contactId: string;
};

export const ContactDetailSection = ({ contactId }: Props) => {

  const showEditUserDialog = useBoolean();

  const { t } = useTranslate();

  const tenantType = useOrgTenant();

  const { data: contact, isFetching: isLoadingContact } = useGetContactByIdQuery(contactId, {
    skip: !contactId,
  });

  return (
    <Stack direction="column" spacing={2}>

      {
        contact?.thread?.id && (
          <Card>
            <CardHeader
              title={
                <Stack direction="row" gap={1} justifyContent="start" alignItems="center">
                  <Iconify icon="uil:notes" />
                  <Box>{t('contacts.detail.thread.title')}</Box>
                </Stack>
              }
            />
            <CardContent>
              <PostCommentForm thread_id={contact?.thread?.id} />
              <PostCommentList thread_id={contact?.thread?.id} />
            </CardContent>
          </Card>
        )
      }

    </Stack>
  )
};